import dayjs from "dayjs";

export type PeriodKey = "hoy" | "ayer" | "semana" | "mes";

export const PERIOD_OPTIONS: { value: PeriodKey; label: string }[] = [
  { value: "hoy", label: "Hoy" },
  { value: "ayer", label: "Ayer" },
  { value: "semana", label: "Esta semana" },
  { value: "mes", label: "Este mes" },
];

export const periodLabel = (period: PeriodKey) =>
  PERIOD_OPTIONS.find((el) => el.value === period)?.label ?? "";

/** Rango [inicio, fin] en formato YYYY-MM-DD, igual al que usa el RangePicker de las tablas */
export const periodRange = (period: PeriodKey): [string, string] => {
  const fmt = "YYYY-MM-DD";
  switch (period) {
    case "ayer": {
      const d = dayjs().subtract(1, "day").format(fmt);
      return [d, d];
    }
    case "semana":
      return [
        dayjs().startOf("week").format(fmt),
        dayjs().endOf("week").format(fmt),
      ];
    case "mes":
      return [
        dayjs().startOf("month").format(fmt),
        dayjs().endOf("month").format(fmt),
      ];
    default: {
      const d = dayjs().format(fmt);
      return [d, d];
    }
  }
};
